module.exports = __webpack_public_path__ + "img/SCC_pDC.1d8d6606.png";